import React from 'react';

import CompanyCard from './CompanyCard';
import Reveal from './primitives/Reveal';
import WordReveal from './primitives/WordReveal';
import useMediaQuery from '../hooks/useMediaQuery';
import { companies } from '../data/site';

export default function Companies() {
    const stacked = useMediaQuery('(min-width: 981px)');

    return (
        <section className="section companies" id="companies">
            <div className="shell">
                <div className="section-head">
                    <Reveal y={18}>
                        <span className="t-eyebrow">Our companies</span>
                    </Reveal>
                    <WordReveal as="h2" className="t-h2" text="One group. Three specialists." />
                    <Reveal delay={0.12}>
                        <p className="t-lead">
                            Each company runs its own crews, licences, and expertise. Together
                            they cover a project end to end, so the wiring, the power, and the
                            walls are never three separate arguments.
                        </p>
                    </Reveal>
                </div>
            </div>

            <div className={`shell deck${stacked ? ' deck--stacked' : ''}`}>
                {companies.map((company, index) => (
                    <CompanyCard
                        key={company.id}
                        company={company}
                        index={index}
                        count={companies.length}
                        stacked={stacked}
                    />
                ))}
            </div>
        </section>
    );
}
